import { PublicClientApplication } from '@azure/msal-browser'

import { loginRequest, msalConfig } from './authConfig'

export const msalInstance = new PublicClientApplication(msalConfig)

export const acquireAccessToken = async (): Promise<string> => {
  const activeAccount = msalInstance.getActiveAccount() // This will only return a non-null value if you have logic somewhere else that calls the setActiveAccount API
  const accounts = msalInstance.getAllAccounts()

  if (!activeAccount && accounts.length === 0) {
    /*
     * User is not signed in. Throw error or wait for user to login.
     * Do not attempt to log a user in outside of the context of MsalProvider
     */
    console.warn('No active account found for token acquisition')
    return ''
  }
  const request = {
    scopes: loginRequest.scopes,
    account: activeAccount || accounts[0],
  }

  try {
    const authResult = await msalInstance.acquireTokenSilent(request)
    console.log('Token acquired successfully')
    return authResult.accessToken
  } catch (error) {
    console.error('Silent token acquisition failed:', error)

    // If silent token acquisition fails, we might need to redirect for re-authentication
    // but we should not do this automatically in a SignalR context as it would disrupt the user experience
    // Instead, log the error and return empty string - the calling code should handle this

    return ''
  }
}
